// extracted by mini-css-extract-plugin
export default {"main":"styles_main__NaIs-","content":"styles_content__8fhYT"};